// Dual-ack gate for the cart checkout button.
//
// Enables `[data-northbound-cart-checkout]` only when both checkboxes
// are ticked AND the min-order alert is hidden (the runtime owns
// `[data-northbound-cart-alert]` visibility). Mirrors checkbox state
// into `attributes[disclaimer_*]` hidden inputs so consent is recorded
// on the cart object at submit time.

class CartAcks extends HTMLElement {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll('[data-cart-ack]');
    this.hiddenInputs = this.querySelectorAll('[data-cart-ack-input]');
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  connectedCallback() {
    this.checkboxes.forEach((cb) => cb.addEventListener('change', this.onCheckboxChange));
    window.addEventListener('northbound:cart-pricing-applied', this.refresh);
    window.addEventListener('northbound:community-changed', this.refresh);
    this.refresh();
    // Remove the pre-hydration grayout marker once we've set the real
    // disabled state. Liquid ships `[data-cart-acks-pending]` on the
    // checkout button so CSS can ghost it at first paint without us
    // having to ship `disabled` (which would render as Dawn's 50%-opacity
    // ghost). After refresh() runs, we own `disabled` directly.
    document
      .querySelectorAll('[data-northbound-cart-checkout][data-cart-acks-pending]')
      .forEach((btn) => btn.removeAttribute('data-cart-acks-pending'));
  }

  disconnectedCallback() {
    this.checkboxes.forEach((cb) => cb.removeEventListener('change', this.onCheckboxChange));
    window.removeEventListener('northbound:cart-pricing-applied', this.refresh);
    window.removeEventListener('northbound:community-changed', this.refresh);
  }

  onCheckboxChange(event) {
    const cb = event.currentTarget;
    const key = cb.getAttribute('data-cart-ack');
    const hidden = this.querySelector('[data-cart-ack-input="' + key + '"]');
    if (hidden) {
      hidden.value = cb.checked ? 'yes' : '';
    }
    this.refresh();
  }

  isMinOrderMet() {
    const cart = this.closest('[data-northbound-cart]') || document.querySelector('[data-northbound-cart]');
    if (cart && cart.getAttribute('data-northbound-cart-pricing-loading') === 'true') return false;

    const alert = cart
      ? cart.querySelector('[data-northbound-cart-alert]')
      : document.querySelector('[data-northbound-cart-alert]');
    if (!alert) return true;
    return alert.hidden || alert.hasAttribute('hidden');
  }

  allChecked() {
    return Array.from(this.checkboxes).every((cb) => cb.checked);
  }

  refresh() {
    const ready = this.allChecked() && this.isMinOrderMet();
    document.querySelectorAll('[data-northbound-cart-checkout]').forEach((btn) => {
      if ('disabled' in btn) {
        btn.disabled = !ready;
      } else {
        btn.hidden = !ready;
        btn.toggleAttribute('aria-disabled', !ready);
      }
    });
  }
}

if (!customElements.get('cart-acks')) {
  customElements.define('cart-acks', CartAcks);
}
